/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedHeadLinkTags_metadata$ref = any;
type SharedHeadMetaTags_metadata$ref = any;
type SharedHeadScriptTags_metadata$ref = any;
type SharedHeadTitleTag_metadata$ref = any;
export type SbSharedHead_itemSearch$ref = any;
export type SbSharedHead_itemSearch = {
    readonly meta: {
        readonly canonical: string | null;
        readonly prev: string | null;
        readonly disableIndexing: boolean | null;
        readonly " $fragmentRefs": SharedHeadTitleTag_metadata$ref & SharedHeadMetaTags_metadata$ref & SharedHeadLinkTags_metadata$ref & SharedHeadScriptTags_metadata$ref;
    } | null;
    readonly languageAnnotations: ReadonlyArray<{
        readonly href: string | null;
        readonly hrefLang: string | null;
        readonly available: boolean | null;
    } | null> | null;
    readonly pageType: string | null;
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly item: {
                readonly photos: ReadonlyArray<{
                    readonly versions: ReadonlyArray<{
                        readonly webPath: string | null;
                    } | null> | null;
                } | null> | null;
            } | null;
        } | null;
    } | null> | null;
    readonly " $refType": SbSharedHead_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedHead_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "canonical",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "prev",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "disableIndexing",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadTitleTag_metadata",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadMetaTags_metadata",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadLinkTags_metadata",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedHeadScriptTags_metadata",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "languageAnnotations",
      "storageKey": null,
      "args": null,
      "concreteType": "LanguageAnnotations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "href",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hrefLang",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "available",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "photos",
                  "storageKey": "photos(limit:1)",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "limit",
                      "value": 1
                    }
                  ],
                  "concreteType": "ItemPhoto",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "versions",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ItemPhotoVersion",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "webPath",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'b3a1fb19d4880fa992f6728305d04b3d';
export default node;
